var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#626262",
    strokeLinecap: "round",
    strokeWidth: 1.333,
    d: "M6 8.5h4M6 5.834h2.667M6 11.167h2.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#626262",
    strokeWidth: 1.333,
    d: "M12.666 8.5v1.334c0 1.885 0 2.828-.585 3.414-.586.586-1.529.586-3.415.586H7.333c-1.886 0-2.828 0-3.414-.586s-.586-1.529-.586-3.414v-4c0-1.886 0-2.829.586-3.415s1.528-.586 3.414-.586"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#626262",
    strokeLinecap: "round",
    strokeWidth: 1.333,
    d: "M12 1.834v4M14 3.834h-4"
  })));
};
export default SvgFile;